// Labels, confirmations and feedback for Menu page actions (ar/en).
const TEXT = {
  ar: {
    actions: "إجراءات",
    menuActions: "إجراءات قائمة الطعام",
    sectionActions: "إجراءات القسم",
    itemActions: "إجراءات الصنف",
    additionActions: "إجراءات الإضافة",
    // menu
    rename: "تعديل الاسم",
    duplicate: "نسخ كقائمة طعام جديدة",
    manageBranches: "إدارة الفروع",
    viewHistory: "عرض السجل",
    restaurantHistory: "سجل المطعم (كل قوائم الطعام والإضافات)",
    archive: "أرشفة",
    archiveMenu: "أرشفة قائمة الطعام",
    restore: "استعادة",
    restoreMenu: "استعادة قائمة الطعام",
    activate: "تفعيل قائمة الطعام",
    exportExcel: "تصدير Excel",
    importFile: "استيراد ملف (استبدال المحتوى)",
    importAppend: "استيراد ملف (إضافة للمحتوى)",
    confirmAppend: "إضافة أقسام الملف إلى قائمة الطعام هذه؟",
    confirmAppendBody: "الأقسام الحالية تبقى كما هي، وتُضاف أقسام الملف بعدها.",
    additions: "إضافات المطعم",
    archivedContent: "الأقسام والأصناف المؤرشفة",
    confirmArchiveMenu: "أرشفة قائمة الطعام هذه؟",
    confirmArchiveMenuBody: "سيُفصل عن كل الفروع ويصبح للقراءة فقط. يمكنك استعادته لاحقاً.",
    confirmRestoreMenu: "استعادة قائمة الطعام هذه؟",
    confirmRestoreMenuBody: "ستعود نفس قائمة الطعام كمسودة. فعّلها ثم اربطها بالفروع.",
    menuArchived: "تمت أرشفة قائمة الطعام",
    menuRestored: "تمت استعادة قائمة الطعام كمسودة",
    archivedReadOnly: "قائمة الطعام هذه مؤرشفة وللقراءة فقط. يمكنك عرض السجل أو استعادتها.",
    // sections
    addItem: "إضافة صنف",
    renameSection: "تعديل اسم القسم",
    moveUp: "تحريك لأعلى",
    moveDown: "تحريك لأسفل",
    copySection: "نسخ القسم إلى قائمة طعام",
    archiveSection: "أرشفة القسم",
    confirmArchiveSection: "أرشفة هذا القسم؟",
    confirmArchiveSectionBody: "يمكن استعادته من «الأقسام والأصناف المؤرشفة».",
    // items
    edit: "تعديل",
    changeImage: "تغيير الصورة",
    addImage: "إضافة صورة",
    removeImage: "حذف الصورة",
    confirmRemoveImage: "حذف صورة هذا الصنف؟",
    hideAll: "إخفاء في كل الفروع",
    showAll: "إظهار في كل الفروع",
    branchVisibility: "الظهور حسب الفرع",
    moveToSection: "نقل إلى قسم آخر",
    copyItem: "نسخ الصنف إلى قائمة طعام",
    itemHistory: "سجل الصنف",
    archiveItem: "أرشفة الصنف",
    confirmArchiveItem: "أرشفة هذا الصنف؟",
    confirmArchiveItemBody: "يختلف عن الإخفاء: الصنف يُزال من قائمة الطعام ويمكن استعادته لاحقاً.",
    // branches
    branchesTitle: "الفروع التي تستخدم قائمة الطعام هذه",
    branchesHint: "الفرع يمكن أن يستخدم أكثر من قائمة طعام. إزالة الفرع من قائمة الطعام هذه لا تؤثر على قوائم الطعام الأخرى التي يستخدمها.",
    branchesDraft: "فعّل قائمة الطعام أولاً ليمكن ربطها بالفروع.",
    branchesArchived: "قائمة الطعام مؤرشفة ولا ترتبط بفروع.",
    searchBranches: "بحث في الفروع",
    selectAll: "تحديد الكل",
    clearAll: "إلغاء التحديد",
    assigned: "مرتبط",
    willAssign: "سيُربط",
    willRemove: "سيُزال",
    alsoUses: (names) => `يستخدم أيضاً: ${names}`,
    applyChanges: (add, remove) => `حفظ (${add} ربط، ${remove} إزالة)`,
    noChanges: "لا توجد تغييرات",
    noBranches: "لا توجد فروع لهذا المطعم",
    noBranchMatch: "لا توجد فروع مطابقة",
    progress: (done, total) => `جاري الحفظ ${done}/${total}…`,
    branchesSaved: (add, remove) => `تم ربط ${add} وإزالة ${remove} فرع`,
    partialFailure: (failed) => `تعذر حفظ ${failed} تغيير. التغييرات الأخرى حُفظت.`,
    confirmRemoveBranches: (n) => `إزالة ${n} فرع من قائمة الطعام هذه؟`,
    confirmRemoveBranchesBody: "إعدادات إخفاء الأصناف لهذه الفروع في قائمة الطعام هذه ستُحذف. قوائم الطعام الأخرى لهذه الفروع لا تتأثر.",
    // item visibility
    visibilityTitle: "ظهور الصنف في الفروع",
    visibilityHint: "الإخفاء في فرع يختلف عن الأرشفة: الصنف يبقى في قائمة الطعام ويختفي من الفرع فقط.",
    visibleIn: "ظاهر",
    hiddenIn: "مخفي",
    hiddenEverywhereNote: "الصنف مخفي في كل الفروع حالياً. إعدادات الفروع تُطبّق عند إظهاره.",
    showSelected: "إظهار في الكل",
    hideSelected: "إخفاء في الكل",
    visibilitySaved: "تم حفظ ظهور الصنف",
    noAssignedBranches: "لا توجد فروع مرتبطة بقائمة الطعام هذه.",
    // move
    moveTitle: "نقل الصنف",
    targetSection: "القسم الجديد",
    move: "نقل",
    moved: "تم نقل الصنف",
    // archived content
    archivedSections: "أقسام مؤرشفة",
    archivedItems: "أصناف مؤرشفة",
    nothingArchived: "لا توجد أقسام أو أصناف مؤرشفة.",
    restoreSectionFirst: "استعد القسم أولاً",
    restored: "تمت الاستعادة",
    loading: "جاري التحميل…",
    // additions
    deactivate: "إيقاف",
    reactivate: "إعادة تفعيل",
    inactive: "موقوفة",
    archivedTag: "مؤرشفة",
    whereUsed: "أين تُستخدم؟",
    notUsed: "غير مستخدمة في أي صنف.",
    showArchivedAdditions: "إظهار المؤرشفة",
    confirmArchiveAddition: "أرشفة هذه الإضافة؟",
    confirmArchiveAdditionBody: "يجب فصلها عن كل الأصناف أولاً. يمكن استعادتها لاحقاً.",
    activeLabel: "مفعّلة (تظهر للربط بالأصناف)",
    moveOptionUp: "تحريك الخيار لأعلى",
    moveOptionDown: "تحريك الخيار لأسفل",
    copyToRestaurant: "نسخ لمطعم آخر",
    // common
    save: "حفظ",
    cancel: "إلغاء",
    close: "إغلاق",
    done: "تم",
  },
  en: {
    actions: "Actions",
    menuActions: "Menu actions",
    sectionActions: "Section actions",
    itemActions: "Item actions",
    additionActions: "Addition actions",
    rename: "Rename",
    duplicate: "Duplicate as new menu",
    manageBranches: "Manage branches",
    viewHistory: "View history",
    restaurantHistory: "Restaurant history (all menus and additions)",
    archive: "Archive",
    archiveMenu: "Archive menu",
    restore: "Restore",
    restoreMenu: "Restore menu",
    activate: "Activate menu",
    exportExcel: "Export Excel",
    importFile: "Import file (replace content)",
    importAppend: "Import file (add to content)",
    confirmAppend: "Add the file's sections to this menu?",
    confirmAppendBody: "Current sections stay as they are; the file's sections are added after them.",
    additions: "Restaurant additions",
    archivedContent: "Archived sections & items",
    confirmArchiveMenu: "Archive this menu?",
    confirmArchiveMenuBody: "It is removed from every branch and becomes read-only. You can restore it later.",
    confirmRestoreMenu: "Restore this menu?",
    confirmRestoreMenuBody: "The same menu comes back as a draft. Activate it, then assign branches.",
    menuArchived: "Menu archived",
    menuRestored: "Menu restored as a draft",
    archivedReadOnly: "This menu is archived and read-only. You can view its history or restore it.",
    addItem: "Add item",
    renameSection: "Rename section",
    moveUp: "Move up",
    moveDown: "Move down",
    copySection: "Copy section to another menu",
    archiveSection: "Archive section",
    confirmArchiveSection: "Archive this section?",
    confirmArchiveSectionBody: "You can restore it from “Archived sections & items”.",
    edit: "Edit",
    changeImage: "Change image",
    addImage: "Add image",
    removeImage: "Remove image",
    confirmRemoveImage: "Remove this item's image?",
    hideAll: "Hide in all branches",
    showAll: "Show in all branches",
    branchVisibility: "Visibility by branch",
    moveToSection: "Move to another section",
    copyItem: "Copy item to another menu",
    itemHistory: "Item history",
    archiveItem: "Archive item",
    confirmArchiveItem: "Archive this item?",
    confirmArchiveItemBody: "Not the same as hiding: the item leaves the menu. You can restore it later.",
    branchesTitle: "Branches using this menu",
    branchesHint: "A branch can use several menus. Removing it from this menu does not affect its other menus.",
    branchesDraft: "Activate the menu first to assign branches.",
    branchesArchived: "Archived menus have no branches.",
    searchBranches: "Search branches",
    selectAll: "Select all",
    clearAll: "Clear",
    assigned: "Assigned",
    willAssign: "Will be assigned",
    willRemove: "Will be removed",
    alsoUses: (names) => `Also uses: ${names}`,
    applyChanges: (add, remove) => `Save (${add} assign, ${remove} remove)`,
    noChanges: "No changes",
    noBranches: "This restaurant has no branches",
    noBranchMatch: "No matching branches",
    progress: (done, total) => `Saving ${done}/${total}…`,
    branchesSaved: (add, remove) => `Assigned ${add}, removed ${remove} ${add + remove === 1 ? "branch" : "branches"}`,
    partialFailure: (failed) => `${failed} ${failed === 1 ? "change" : "changes"} could not be saved. The others were saved.`,
    confirmRemoveBranches: (n) => `Remove ${n} ${n === 1 ? "branch" : "branches"} from this menu?`,
    confirmRemoveBranchesBody: "Their item hide settings in this menu are cleared. Their other menus are not affected.",
    visibilityTitle: "Item visibility by branch",
    visibilityHint: "Hiding in a branch is not archiving: the item stays in the menu and is only hidden there.",
    visibleIn: "Visible",
    hiddenIn: "Hidden",
    hiddenEverywhereNote: "This item is currently hidden in all branches. Branch settings apply once it is shown.",
    showSelected: "Show in all",
    hideSelected: "Hide in all",
    visibilitySaved: "Item visibility saved",
    noAssignedBranches: "No branches use this menu.",
    moveTitle: "Move item",
    targetSection: "New section",
    move: "Move",
    moved: "Item moved",
    archivedSections: "Archived sections",
    archivedItems: "Archived items",
    nothingArchived: "No archived sections or items.",
    restoreSectionFirst: "Restore its section first",
    restored: "Restored",
    loading: "Loading…",
    deactivate: "Deactivate",
    reactivate: "Reactivate",
    inactive: "Inactive",
    archivedTag: "Archived",
    whereUsed: "Where is it used?",
    notUsed: "Not linked to any item.",
    showArchivedAdditions: "Show archived",
    confirmArchiveAddition: "Archive this addition?",
    confirmArchiveAdditionBody: "Unlink it from every item first. You can restore it later.",
    activeLabel: "Active (available to link to items)",
    moveOptionUp: "Move option up",
    moveOptionDown: "Move option down",
    copyToRestaurant: "Copy to another restaurant",
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    done: "Done",
  },
};

export const menuActionsText = (lang) => TEXT[lang] || TEXT.ar;
